module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.arrow),
      callback: function($$v) {
        _vm.arrow = $$v
      },
      expression: "arrow"
    }
  }, [_c('strong', [_vm._v("Arrow")])]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.arrow
    },
    model: {
      value: (_vm.arrowBoth),
      callback: function($$v) {
        _vm.arrowBoth = $$v
      },
      expression: "arrowBoth"
    }
  }, [_vm._v("Both")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.arrow
    },
    model: {
      value: (_vm.arrowHover),
      callback: function($$v) {
        _vm.arrowHover = $$v
      },
      expression: "arrowHover"
    }
  }, [_vm._v("Hover")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Icon Pack"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "e.g. mdi, fa or other"
    },
    model: {
      value: (_vm.iconPack),
      callback: function($$v) {
        _vm.iconPack = $$v
      },
      expression: "iconPack"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Icon Size"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.iconSize),
      callback: function($$v) {
        _vm.iconSize = $$v
      },
      expression: "iconSize"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("is-small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("is-medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("is-large")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Icon Prev"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.iconPrev),
      callback: function($$v) {
        _vm.iconPrev = $$v
      },
      expression: "iconPrev"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Icon Next"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.iconNext),
      callback: function($$v) {
        _vm.iconNext = $$v
      },
      expression: "iconNext"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "arrow": _vm.arrow,
      "arrow-both": _vm.arrowBoth,
      "arrow-hover": _vm.arrowHover,
      "icon-pack": _vm.iconPack,
      "icon-prev": _vm.iconPrev,
      "icon-next": _vm.iconNext,
      "icon-size": _vm.iconSize
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050e109d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExArrow.vue
// module id = 983
// module chunks = 3 167